<template>
  <aside class="sidebar" :class="[{ collapsed: isSidebarClosed }, shopInfo.plan + '-plan']"
    v-if="windowWidth >= 768 && mode == 'shop'">
    <a :href="url" class="logo justify-content-center justify-content-lg-start align-items-center">
      <i class="icon icon-direction-arrow"></i>
      <span class="logo__text typo-paragraph12">{{ $t("sidebar.backShopify") }}</span>
    </a>

    <section class="sidenav mt-2">
      <PerfectScrollbar class="scrollBody" :options="scrollOptions">
        <router-link :to="{ name: 'Dashboard' }" class="nav-link dashboard flex-shrink-0"
          :class="{ 'popover--disabled': isActive.dashBoard }"
          v-popover:tooltip.right="this.$t('sidebar.dashboardTooltip')">
          <i class="icon icon-new-dashboard"></i>
          <span class="text-item">{{ $t("sidebar.dashboard") }}</span>
        </router-link>
        <article class="pages d-none d-lg-flex flex-column">
          <div class="nav-link subtitle">
            <span>{{ $t("sidebar.shopifyPage") }}</span>
          </div>

          <router-link :to="goTo('LandingPages')" class="nav-link" v-if="permission.subpages"
            :class="{ 'popover--disabled': isActive.subPages }" v-popover:tooltip.right="$t('page.subpagesTooltip')">
            <i class="icon icon-new-landing-page"></i>
            <span class="text-item">{{ $tc("page.newLandingPages", 2) }}</span>
            <a @mouseover="isHoverToCreatePage = true; isHoverToCreateLandingPage = true" @mouseleave="isHoverToCreatePage = false; isHoverToCreateLandingPage = false"
              v-popover:tooltip.right="isGemPagesMixed ? $t('gemAi.createPagePoweredBy') : $t('dashboard.createNewPageTxt')"
              class="btn nav-link__quick-add" @click.stop
              @click.prevent="onCreateNewPage('subpages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_LANDING_PAGE_SHORTCUT_CLICKED)">
              <i class="icon icon-new-plus-small text-light1-small text-light1 m-0"></i>
            </a>
          </router-link>
          <a class="nav-link disabled" v-popover:tooltip.right="$t('page.pleaseUpgrade')" v-else>
            <i class="icon icon-new-landing-page"></i>
            <span class="text-item">{{ $tc("page.newLandingPages", 2) }}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-auto mr-xl-3 mr-lg-1 mr-mlg-2">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 7C3.22386 7 3 7.22386 3 7.5V14.5C3 14.7761 3.22386 15 3.5 15H12.5C12.7761 15 13 14.7761 13 14.5V7.5C13 7.22386 12.7761 7 12.5 7H3.5ZM2 7.5C2 6.67158 2.67158 6 3.5 6H12.5C13.3284 6 14 6.67158 14 7.5V14.5C14 15.3284 13.3284 16 12.5 16H3.5C2.67158 16 2 15.3284 2 14.5V7.5Z" fill="#A6A6A6" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C6.34314 1 5 2.34315 5 4V6.5C5 6.77614 4.77614 7 4.5 7C4.22386 7 4 6.77614 4 6.5V4C4 1.79086 5.79086 0 8 0C10.2091 -3.57628e-07 12 1.79086 12 4V6.5C12 6.77614 11.7761 7 11.5 7C11.2239 7 11 6.77614 11 6.5V4C11 2.34314 9.65685 1 8 1Z" fill="#A6A6A6" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.70711 10.2929C8.31658 9.90237 7.68342 9.90237 7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071C9.09763 11.3166 9.09763 10.6834 8.70711 10.2929ZM9.41421 9.58579C8.63316 8.80474 7.36684 8.80474 6.58579 9.58579C5.80474 10.3668 5.80474 11.6332 6.58579 12.4142C7.36684 13.1953 8.63316 13.1953 9.41421 12.4142C10.1953 11.6332 10.1953 10.3668 9.41421 9.58579Z" fill="#A6A6A6" />
            </svg>
          </a>

          <router-link :to="goTo('HomePages')" class="nav-link" v-if="permission.homepages"
            :class="{ 'popover--disabled': isActive.homePages }" v-popover:tooltip.right="$t('page.homepagesTooltip')">
            <i class="icon icon-new-homepage"></i>
            <span class="text-item">{{ $tc("page.homepages", 2) }}</span>
            <a 
              v-popover:tooltip.right="$t('dashboard.createNewPageTxt')"
              class="btn nav-link__quick-add"
              @click.stop @click.prevent="onCreateNewPage('homepages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_HOME_PAGE_SHORTCUT_CLICKED)">
              <i class="icon icon-new-plus-small text-light1 m-0"></i>
            </a>
          </router-link>
          <a class="nav-link disabled" v-popover:tooltip.right="$t('page.pleaseUpgrade')" v-else>
            <i class="icon icon-new-homepage"></i>
            <span class="text-item">{{ $tc("page.homepages", 2) }}</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="ml-auto mr-xl-3 mr-lg-1 mr-mlg-2">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 7C3.22386 7 3 7.22386 3 7.5V14.5C3 14.7761 3.22386 15 3.5 15H12.5C12.7761 15 13 14.7761 13 14.5V7.5C13 7.22386 12.7761 7 12.5 7H3.5ZM2 7.5C2 6.67158 2.67158 6 3.5 6H12.5C13.3284 6 14 6.67158 14 7.5V14.5C14 15.3284 13.3284 16 12.5 16H3.5C2.67158 16 2 15.3284 2 14.5V7.5Z" fill="#A6A6A6" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1C6.34314 1 5 2.34315 5 4V6.5C5 6.77614 4.77614 7 4.5 7C4.22386 7 4 6.77614 4 6.5V4C4 1.79086 5.79086 0 8 0C10.2091 -3.57628e-07 12 1.79086 12 4V6.5C12 6.77614 11.7761 7 11.5 7C11.2239 7 11 6.77614 11 6.5V4C11 2.34314 9.65685 1 8 1Z" fill="#A6A6A6" />
              <path fill-rule="evenodd" clip-rule="evenodd" d="M8.70711 10.2929C8.31658 9.90237 7.68342 9.90237 7.29289 10.2929C6.90237 10.6834 6.90237 11.3166 7.29289 11.7071C7.68342 12.0976 8.31658 12.0976 8.70711 11.7071C9.09763 11.3166 9.09763 10.6834 8.70711 10.2929ZM9.41421 9.58579C8.63316 8.80474 7.36684 8.80474 6.58579 9.58579C5.80474 10.3668 5.80474 11.6332 6.58579 12.4142C7.36684 13.1953 8.63316 13.1953 9.41421 12.4142C10.1953 11.6332 10.1953 10.3668 9.41421 9.58579Z" fill="#A6A6A6" />
            </svg>
          </a>
          <template v-if="permission.productpages">
            <router-link :to="goTo('ProductPages')" class="nav-link open"
              :class="{ 'popover--disabled': isActive.productPages }"
              v-popover:tooltip.right="$t('page.productpagesTooltip')">
              <i class="icon icon-new-product-page"></i>

              <span class="text-item">{{ $tc("page.productpages", 2) }}</span>
              <a 
                v-popover:tooltip.right="$t('dashboard.createNewPageTxt')"
                class="btn nav-link__quick-add" @click.stop
                @click.prevent="onCreateNewPage('productpages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_PRODUCT_PAGE_SHORTCUT_CLICKED)">
                <i class="icon icon-new-plus-small m-0"></i>
              </a>
            </router-link>
          </template>
          <router-link
            class="nav-link open"
            :class="{ 'popover--disabled': isActive.productPages }"
            v-popover:tooltip.right="$t('page.productpagesTooltip')"
            :to="{
              name: 'PricingOnboarding',
              params: {
                id: patIdsPricingOnboard.product
              }
            }"
            v-else
          >
            <i class="icon icon-new-product-page"></i>
            <span class="text-item">{{ $tc("page.productpages", 2) }}</span>
            <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.build") }}</span>
          </router-link>
          <template v-if="permission.collectionpages">
            <router-link :to="goTo('CollectionPages')" class="nav-link open"
              :class="{ 'popover--disabled': isActive.collectionPages }"
              v-popover:tooltip.right="$t('page.collectionpagesTooltip')">
              <i class="icon icon-new-collection-page"></i>
              <span class="text-item">{{ $tc("page.collectionpages", 2) }}</span>
              <a 
              v-popover:tooltip.right="$t('dashboard.createNewPageTxt')"
                class="btn nav-link__quick-add" @click.stop
                @click.prevent="onCreateNewPage('collectionpages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_COLLECTION_PAGE_SHORTCUT_CLICKED)">
                <i class="icon icon-new-plus-small m-0"></i>
              </a>
            </router-link>
          </template>
          <router-link
            class="nav-link open "
            v-popover:tooltip.right="$t('page.pleaseUpgrade')"
            :to="{
              name: 'PricingOnboarding',
              params: {
                id: patIdsPricingOnboard.collection
              }
            }"
            v-else
          >
            <i class="icon icon-new-collection-page"></i>
            <span class="text-item">{{ $tc("page.collectionpages", 2) }}</span>
            <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.build") }}</span>
          </router-link>
          <router-link :to="goTo('ArticlePages')" class="nav-link" v-if="permission.articlepages"
            :class="{ 'popover--disabled': isActive.articlePages }"
            v-popover:tooltip.right="$t('sidebar.blogArtTooltip')">
            <i class="icon icon-new-blog"></i>
            <span class="text-item">{{ $t("page.blog") }}</span>
            <a 
              v-popover:tooltip.right="$t('dashboard.createNewPageTxt')"
              class="btn nav-link__quick-add" @click.stop
              @click.prevent="onCreateNewPage('articlepages', DASHBOARD_SIDEBAR_EVENT.CREATE_NEW_BLOG_POST_SHORTCUT_CLICKED)">
              <i class="icon icon-new-plus-small m-0"></i>
            </a>
          </router-link>
          <router-link
            class="nav-link "
            v-popover:tooltip.right="$t('page.pleaseUpgrade')"
            :to="{
              name: 'PricingOnboarding',
              params: {
                id: patIdsPricingOnboard.blog
              }
            }"
            v-else
          >
            <i class="icon icon-new-blog"></i>
            <span class="text-item">{{ $t("page.blog") }}</span>
            <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.build") }}</span>
          </router-link>
        </article>
        <article class="pages d-none d-lg-flex flex-column">
          <div class="nav-link subtitle">
            <span>{{ $t("sidebar.opimization") }}</span>
          </div>
          <template v-if="isGemPagesV7">
            <div class="nav-link disabled">
              <i class="icon icon-ab-testing"></i>
              <span class="text-item">{{ $t("analytic.ab.title") }}</span>
              <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.upcoming") }}</span>
            </div>
          </template>
          <template v-else>
            <router-link :to="{ name: 'ABTesting' }" class="nav-link" :class="{ 'popover--disabled': isActive.ab }"
              v-popover:tooltip.right="$t('analytic.ab.description')" v-if="permission.analytics"
              :key="$t('analytic.ab.description')">
              <i class="icon icon-ab-testing"></i>
              <span class="text-item">{{ $t("analytic.ab.title") }}</span>
              <!-- <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("capitalize.pro") }}</span> -->
            </router-link>
            <router-link
              v-else
              :to="{
                name: 'PricingOnboarding',
                params: {
                  id: patIdsPricingOnboard.ab_testing
                }
              }"
              class="nav-link"
              :class="{ 'popover--disabled': isActive.ab }"
              v-popover:tooltip.right="$t('analytic.ab.description')"
            >
              <i class="icon icon-ab-testing"></i>
              <span class="text-item">{{ $t("analytic.ab.title") }}</span>
              <span class="badge badge-pro" style="transform: translateY(1px);">{{ $t("dataNewPlan.plan.build") }}</span>
            </router-link>
          </template>
          <router-link :to="{ name: 'Integrations' }" class="nav-link"
            :class="{ 'popover--disabled': isActive.integration }" v-popover:tooltip.right="$t('integration.tooltip')">
            <i class="icon icon-integration-2"></i>
            <span class="text-item">{{ $t("integration.title") }}</span>
          </router-link>
        </article>

        <article class="pages d-none d-lg-flex flex-column" v-if="showInstant">
          <div class="nav-link subtitle">
            <span>{{ $t("upperCase.instantPages") }}</span>
          </div>

          <router-link :to="{ path: '/instant/static' }" class="nav-link"
            :class="{ 'popover--disabled': isActive.instant }" v-popover:tooltip.right="$t('page.instantpagesTooltip')">
            <i class="icon icon-instant-landing-page"></i>
            <span class="text-item">{{ $t("page.instantpages") }}</span>
            <span class="badge badge-instant" style="transform: translateY(1px);">{{ $t("capitalize.beta") }}</span>
          </router-link>
          <!-- <a class="nav-link disabled" v-popover:tooltip.right="$t('page.pleaseUpgrade')" v-else>
            <i class="icon icon-new-landing-page"></i>
            <span class="text-item">{{ $t("page.instantpages") }}</span>
            <span class="badge badge-warn" style="transform: translateY(1px);">{{ $t("capitalize.beta") }}</span>
            <i class="icon icon-new-lock ml-auto mr-xl-3 mr-lg-1 mr-mlg-2"></i>
          </a> -->
        </article>
        <article class="pages d-none d-lg-flex flex-column">
          <!-- <router-link :to="{ name: 'ThankYouPage' }" class="nav-link" :class="{ 'popover--disabled': isActive.thankYouPage }" v-popover:tooltip.right="$t('thankYouPage.sidebarTooltip')">
            <i class="icon icon-reconvert"></i>
            <span class="text-item">{{ $t("thankYouPage.title") }}</span>
          </router-link> -->
          <!-- <div class="nav-link subtitle">
            <span>{{ $t("upperCase.support") }}</span>
          </div> -->
          <!-- <a href="https://help.gempages.net/" target="_blank" class="nav-link">
            <i class="icon icon-help"></i>
            <span class="text-item">{{ $t("generals.helpCenter.title") }}</span>
          </a> -->
          <div class="nav-link subtitle">
            <span>{{ $t("upperCase.setting") }}</span>
          </div>
          <router-link :to="{ name: 'AccountSettings' }" class="nav-link">
            <i class="icon icon-settings-2"></i>
            <span class="text-item">{{ $tc("generals.setting", 2) }}</span>
          </router-link>
          <!-- <div class="nav-link nav-link-feedback" @click="handleOpenFeedback">
            <i class="icon icon-chat-2"></i>
            <span class="text-item">{{ $t("generals.giveFeedback") }}</span>
          </div> -->
        </article>
      </PerfectScrollbar>
      <Account :account.sync="shopInfo" />
      <!-- <div v-show="isDisplayFeedbackMsg" class="feedback-popover flex-column">
        <span class="typo-title2 typo-semibold mb-1">{{ $t("feedback.tooltip.title") }}</span>
        <span class="weight-400 typo-body4 mb-1">{{ $t("feedback.tooltip.description") }}</span>
        <span class="d-flex flex-grow-1 justify-content-end align-items-center typo-medium typo-body4">
          <span class="feedback-popover_action clickable" @click="gotFeedbackMsg">{{ $t("dashboard.customGotItButton") }}</span>
        </span>
      </div> -->
      <!-- <article class="acc-nav mt-auto">
          <div class="nav-link subtitle">
            <span>{{$t("upperCase.account")}}</span>
          </div>

          <router-link :to="{ name: 'AccountSettings' }" class="nav-link">
            <i class="icon icon-acc-settings"></i>

            <span class="text-item">{{$t("accountSettings.headerTitle")}}</span>
          </router-link>
      </article>-->
    </section>

    <div class="toggler" v-if="windowWidth < 1024" @click="toggleDrawer(null)">
      <i class="icon icon-arrow-right" v-if="isSidebarClosed"></i>
      <i class="icon icon-arrow-left" v-else></i>
    </div>
    <Portal to="tooltips">
      <tooltip :prefix="tooltipPrefix" :maxWidth="tooltipPrefix ? 500 : 190" :pointer="true"
        :width="'auto'" :delay="800" />
    </Portal>
  </aside>
  <aside class="sidebar" :class="{ collapsed: isSidebarClosed }" v-else-if="windowWidth >= 768 && mode == 'agency'">
    <a :href="url" class="logo justify-content-center justify-content-lg-start align-items-center">
      <i class="icon icon-arrow-left"></i>
      <span class="typo-paragraph12">{{ $t("sidebar.backShopify") }}</span>
    </a>

    <section class="sidenav">
      <PerfectScrollbar class="scrollBody">
        <router-link :to="{ name: 'AgencyDashboard' }" class="nav-link dashboard flex-shrink-0" :class="{ 'popover--disabled': isActive.agencyDashboard }" v-popover:tooltip.right="this.$t('agency.storeManager')">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.19999 9.76501C2.66115 9.76501 3.03499 10.1389 3.03499 10.6V17.8C3.03499 18.0016 3.19841 18.165 3.39999 18.165H16.6C16.8016 18.165 16.965 18.0016 16.965 17.8V10.6C16.965 10.1389 17.3388 9.76501 17.8 9.76501C18.2611 9.76501 18.635 10.1389 18.635 10.6V17.8C18.635 18.9239 17.7239 19.835 16.6 19.835H3.39999C2.27609 19.835 1.36499 18.9239 1.36499 17.8V10.6C1.36499 10.1389 1.73883 9.76501 2.19999 9.76501Z" fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.68178 0.165039H17.3184C17.991 0.164761 18.5734 0.631872 18.7191 1.28845L19.8151 6.21885C19.8284 6.27834 19.835 6.3391 19.835 6.40004C19.835 7.85531 18.6553 9.03504 17.2 9.03504C16.504 9.03504 15.8711 8.7652 15.4 8.32443C14.929 8.7652 14.296 9.03504 13.6 9.03504C12.904 9.03504 12.2711 8.7652 11.8 8.32443C11.329 8.7652 10.696 9.03504 10 9.03504C9.30404 9.03504 8.67107 8.7652 8.20004 8.32443C7.72901 8.7652 7.09603 9.03504 6.40004 9.03504C5.70404 9.03504 5.07107 8.7652 4.60004 8.32443C4.12901 8.7652 3.49603 9.03504 2.80004 9.03504C1.34477 9.03504 0.165039 7.85531 0.165039 6.40004C0.165039 6.33914 0.171701 6.27842 0.184907 6.21897L1.28039 1.2873C1.42718 0.631314 2.00959 0.164991 2.68178 0.165039ZM2.86942 1.83504L1.83812 6.47777C1.87771 6.97438 2.29325 7.36504 2.80004 7.36504C3.33299 7.36504 3.76504 6.93299 3.76504 6.40004H5.43504C5.43504 6.93299 5.86709 7.36504 6.40004 7.36504C6.93299 7.36504 7.36504 6.93299 7.36504 6.40004C7.36504 5.93888 7.73888 5.56504 8.20004 5.56504C8.6612 5.56504 9.03504 5.93888 9.03504 6.40004C9.03504 6.93299 9.46708 7.36504 10 7.36504C10.533 7.36504 10.965 6.93299 10.965 6.40004C10.965 5.93888 11.3389 5.56504 11.8 5.56504C12.2612 5.56504 12.635 5.93888 12.635 6.40004C12.635 6.93299 13.0671 7.36504 13.6 7.36504C14.133 7.36504 14.565 6.93299 14.565 6.40004C14.565 5.93888 14.9389 5.56504 15.4 5.56504C15.8612 5.56504 16.235 5.93888 16.235 6.40004C16.235 6.93299 16.6671 7.36504 17.2 7.36504C17.7068 7.36504 18.1223 6.97441 18.1619 6.47783L17.1299 1.83504H2.86942Z" fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.76495 13.6C6.76495 11.8134 8.21332 10.365 9.99995 10.365C11.7866 10.365 13.235 11.8134 13.235 13.6V19C13.235 19.4611 12.8611 19.835 12.4 19.835H7.59995C7.1388 19.835 6.76495 19.4611 6.76495 19V13.6ZM9.99995 12.035C9.13563 12.035 8.43495 12.7357 8.43495 13.6V18.165H11.565V13.6C11.565 12.7357 10.8643 12.035 9.99995 12.035Z" fill="currentColor" />
          </svg>
          <span class="text-item">{{ $t("agency.storeManager") }}</span>
        </router-link>
      </PerfectScrollbar>
      <!-- <Account :account.sync="shopInfo" /> -->
      <AgencyAccount v-if="agencyInfo" :account.sync="agencyInfo" :shops.sync="shops" />
    </section>

    <div class="toggler" v-if="windowWidth < 1024" @click="toggleDrawer(null)">
      <i class="icon icon-arrow-right" v-if="isSidebarClosed"></i>
      <i class="icon icon-arrow-left" v-else></i>
    </div>
    <Portal to="tooltips">
      <tooltip :pointer="true" :width="'auto'" :delay="800" />
    </Portal>
  </aside>

  <SidebarMobile v-else-if="windowWidth < 768 && mode == 'shop'" />
</template>

<script>
import { mapMutations, mapState, mapActions } from "vuex";
// import Logo from "./Logo";
import SidebarMobile from "./SidebarMobile";
import Account from "@/core/components/Account";
import AgencyAccount from "@/modules/Agency/components/Account.vue";
import { DASHBOARD_SIDEBAR_EVENT } from "@/config/constants/trackEventIds";
import dynamicTriggerContent from "@/mixins/dynamicTriggerContent";
// import openFeedbackForm from "@/utils/satismeter";
import { createThemeAndPageV7 } from "@/modules/Instant/utils";

export default {
  name: "Sidebar",
  components: {
    // Logo,
    Account,
    SidebarMobile,
    AgencyAccount
  },
  mixins: [dynamicTriggerContent()],
  props: {
    mode: {
      type: String,
      default: "shop"
    }
  },
  data() {
    return {
      url: "",
      height: 1024,
      windowWidth: 1024,
      prevRoute: null,
      showInstant: false,
      tooltipPrefix: '',
      isHoverToCreatePage: false,
    };
  },
  computed: {
    ...mapState({
      recentPage: state => state.page.pages.recentPage.list,
      drawer: state => state.drawer.status,
      shopInfo: state => state.account.shopInfo,
      isSidebarClosed: state => state.drawer.opening,
      isDisplayFeedbackMsg: state => state.drawer.displayFeedbackMsg,
      permission: state => state.account.permissions,
      planLimitation: state => state.account.shopInfo?.planLimitation
    }),
    ...mapState("agency", {
      shops: state => state.shopList,
      agencyLogged: state => state.logged,
      agencyInfo: state => state.info
    }),
    isActive() {
      return {
        dashBoard: this.$route.name == "Dashboard" ? true : false,
        subPages: this.$route.name == "LandingPages" ? true : false,
        homePages: this.$route.name == "HomePages" ? true : false,
        productPages: this.$route.name == "ProductPages" ? true : false,
        collectionPages: this.$route.name == "CollectionPages" ? true : false,
        articlePages: this.$route.name == "ArticlePages" ? true : false,
        integration: this.$route.name == "Integrations" ? true : false,
        agencyDashboard: this.$route.name == "AgencyDashboard" ? true : false,
        AgencySettings: this.$route.name == "AgencySettings" ? true : false,
        thankYouPage: this.$route.name == "ThankYouPage" ? true : false,
        abTesting: this.$route.name == "ABTesting" ? true : false,
        instant: this.$route.name == "InstantPages" ? true : false
      };
    },
    scrollOptions() {
      return {
        wheelSpeed: 0.25,
        swipeEasing: true,
        wheelPropagation: false,
        suppressScrollX: true
      };
    },
    isGemPagesV7() {
      return (this && this.shopInfo && this.shopInfo.shopType && this.shopInfo.shopType.isGemPagesV7) || window.___gemShopInfo.shopType.isGemPagesV7 || false;
    },
    isGemPagesMixed() {
      return (this && this.shopInfo && this.shopInfo.shopType && this.shopInfo.shopType.isGemPagesMixed) || window.___gemShopInfo.shopType.isGemPagesMixed || false;
    }
  },
  watch: {
    // recentPage() {
    //   this.setDisplayFeedbackMsg();
    // },
    isHoverToCreatePage(newV) {
      if (newV && this.shopInfo.shopType.isGemPagesMixed) {
        this.tooltipPrefix = `<svg width="94" height="18" viewBox="0 0 94 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M7.06871 7.05966C6.99769 6.82955 6.89968 6.62358 6.77468 6.44176C6.65252 6.2571 6.50479 6.09943 6.3315 5.96875C6.16104 5.83807 5.96502 5.74006 5.74343 5.67472C5.52184 5.60653 5.28036 5.57244 5.019 5.57244C4.55025 5.57244 4.13264 5.69034 3.76616 5.92614C3.39968 6.16193 3.11133 6.50852 2.9011 6.96591C2.69371 7.42045 2.59002 7.97443 2.59002 8.62784C2.59002 9.28693 2.69371 9.84517 2.9011 10.3026C3.10849 10.7599 3.39684 11.108 3.76616 11.3466C4.13548 11.5824 4.56445 11.7003 5.05309 11.7003C5.49627 11.7003 5.87979 11.6151 6.20366 11.4446C6.53036 11.2741 6.78178 11.0327 6.95792 10.7202C7.13406 10.4048 7.22212 10.0355 7.22212 9.61222L7.58008 9.66761H5.21076V8.43182H8.75195V9.48011C8.75195 10.2273 8.59286 10.8736 8.27468 11.419C7.9565 11.9645 7.519 12.3849 6.96218 12.6804C6.40536 12.973 5.76616 13.1193 5.04457 13.1193C4.24059 13.1193 3.53462 12.9389 2.92667 12.5781C2.32156 12.2145 1.84854 11.6989 1.50763 11.0312C1.16957 10.3608 1.00053 9.56534 1.00053 8.64489C1.00053 7.94034 1.09996 7.31108 1.29883 6.7571C1.50053 6.20312 1.78178 5.73295 2.14258 5.34659C2.50337 4.95739 2.92667 4.66193 3.41246 4.46023C3.89826 4.25568 4.42667 4.15341 4.99769 4.15341C5.48065 4.15341 5.93093 4.22443 6.34854 4.36648C6.76616 4.50568 7.1369 4.70455 7.46076 4.96307C7.78746 5.22159 8.05593 5.52841 8.26616 5.88352C8.47639 6.23864 8.61417 6.63068 8.67951 7.05966H7.06871ZM13.1103 13.1278C12.454 13.1278 11.8873 12.9915 11.41 12.7188C10.9355 12.4432 10.5705 12.054 10.3148 11.5511C10.0591 11.0455 9.93129 10.4503 9.93129 9.76562C9.93129 9.09233 10.0591 8.50142 10.3148 7.9929C10.5733 7.48153 10.9341 7.08381 11.3972 6.79972C11.8603 6.51278 12.4043 6.36932 13.0293 6.36932C13.4327 6.36932 13.8134 6.43466 14.1713 6.56534C14.5321 6.69318 14.8503 6.89205 15.1259 7.16193C15.4043 7.43182 15.623 7.77557 15.7821 8.19318C15.9412 8.60795 16.0208 9.10227 16.0208 9.67614V10.1491H10.6557V9.10938H14.5421C14.5392 8.81392 14.4753 8.55114 14.3503 8.32102C14.2253 8.08807 14.0506 7.90483 13.8262 7.77131C13.6046 7.63778 13.3461 7.57102 13.0506 7.57102C12.7353 7.57102 12.4583 7.64773 12.2196 7.80114C11.981 7.9517 11.7949 8.15057 11.6614 8.39773C11.5307 8.64205 11.464 8.91051 11.4611 9.20312V10.1108C11.4611 10.4915 11.5307 10.8182 11.6699 11.0909C11.8091 11.3608 12.0037 11.5682 12.2537 11.7131C12.5037 11.8551 12.7963 11.9261 13.1316 11.9261C13.356 11.9261 13.5591 11.8949 13.7409 11.8324C13.9228 11.767 14.0804 11.6719 14.214 11.5469C14.3475 11.4219 14.4483 11.267 14.5165 11.0824L15.9569 11.2443C15.8659 11.625 15.6926 11.9574 15.437 12.2415C15.1841 12.5227 14.8603 12.7415 14.4654 12.8977C14.0705 13.0511 13.6188 13.1278 13.1103 13.1278ZM17.3258 13V6.45455H18.8002V7.56676H18.877C19.0133 7.19176 19.2392 6.89915 19.5545 6.68892C19.8699 6.47585 20.2463 6.36932 20.6838 6.36932C21.127 6.36932 21.5005 6.47727 21.8045 6.69318C22.1113 6.90625 22.3272 7.19744 22.4522 7.56676H22.5204C22.6653 7.20312 22.9096 6.91335 23.2534 6.69744C23.6 6.47869 24.0105 6.36932 24.4849 6.36932C25.0872 6.36932 25.5787 6.55966 25.9593 6.94034C26.34 7.32102 26.5304 7.87642 26.5304 8.60653V13H24.9835V8.84517C24.9835 8.43892 24.8755 8.14205 24.6596 7.95455C24.4437 7.7642 24.1795 7.66903 23.867 7.66903C23.4949 7.66903 23.2037 7.78551 22.9934 8.01847C22.786 8.24858 22.6824 8.5483 22.6824 8.91761V13H21.1696V8.78125C21.1696 8.44318 21.0673 8.1733 20.8627 7.97159C20.661 7.76989 20.3968 7.66903 20.0701 7.66903C19.8485 7.66903 19.6468 7.72585 19.465 7.83949C19.2832 7.95028 19.1383 8.10795 19.0304 8.3125C18.9224 8.5142 18.8684 8.75 18.8684 9.01989V13H17.3258ZM31.1401 13V4.27273H34.4128C35.0833 4.27273 35.6458 4.39773 36.1003 4.64773C36.5577 4.89773 36.9029 5.24148 37.1358 5.67898C37.3716 6.11364 37.4895 6.60795 37.4895 7.16193C37.4895 7.72159 37.3716 8.21875 37.1358 8.65341C36.9 9.08807 36.552 9.4304 36.0918 9.6804C35.6316 9.92756 35.0648 10.0511 34.3915 10.0511H32.2225V8.75142H34.1784C34.5705 8.75142 34.8915 8.68324 35.1415 8.54688C35.3915 8.41051 35.5762 8.22301 35.6955 7.98438C35.8176 7.74574 35.8787 7.47159 35.8787 7.16193C35.8787 6.85227 35.8176 6.57955 35.6955 6.34375C35.5762 6.10795 35.3901 5.92472 35.1373 5.79403C34.8873 5.66051 34.5648 5.59375 34.1699 5.59375H32.7211V13H31.1401ZM40.5609 13.1321C40.1461 13.1321 39.7725 13.0582 39.4402 12.9105C39.1106 12.7599 38.8493 12.5384 38.6561 12.2457C38.4657 11.9531 38.3706 11.5923 38.3706 11.1634C38.3706 10.794 38.4387 10.4886 38.5751 10.2472C38.7115 10.0057 38.8975 9.8125 39.1333 9.66761C39.3691 9.52273 39.6348 9.41335 39.9302 9.33949C40.2285 9.26278 40.5368 9.20739 40.8549 9.1733C41.2385 9.13352 41.5495 9.09801 41.7882 9.06676C42.0268 9.03267 42.2001 8.98153 42.3081 8.91335C42.4189 8.84233 42.4743 8.73295 42.4743 8.58523V8.55966C42.4743 8.23864 42.3791 7.99006 42.1887 7.81392C41.9984 7.63778 41.7243 7.54972 41.3663 7.54972C40.9885 7.54972 40.6887 7.6321 40.4672 7.79688C40.2484 7.96165 40.1007 8.15625 40.024 8.38068L38.5836 8.17614C38.6973 7.77841 38.8848 7.44602 39.1461 7.17898C39.4075 6.90909 39.7271 6.70739 40.1049 6.57386C40.4828 6.4375 40.9004 6.36932 41.3578 6.36932C41.6731 6.36932 41.987 6.40625 42.2995 6.48011C42.612 6.55398 42.8975 6.67614 43.1561 6.84659C43.4146 7.0142 43.622 7.2429 43.7782 7.53267C43.9373 7.82244 44.0169 8.18466 44.0169 8.61932V13H42.5339V12.1009H42.4828C42.389 12.2827 42.2569 12.4531 42.0865 12.6122C41.9189 12.7685 41.7072 12.8949 41.4515 12.9915C41.1987 13.0852 40.9018 13.1321 40.5609 13.1321ZM40.9615 11.9986C41.2711 11.9986 41.5396 11.9375 41.7669 11.8153C41.9941 11.6903 42.1689 11.5256 42.291 11.321C42.416 11.1165 42.4785 10.8935 42.4785 10.652V9.88068C42.4302 9.92045 42.3478 9.95739 42.2314 9.99148C42.1177 10.0256 41.9899 10.0554 41.8478 10.081C41.7058 10.1065 41.5652 10.1293 41.426 10.1491C41.2868 10.169 41.166 10.1861 41.0637 10.2003C40.8336 10.2315 40.6277 10.2827 40.4458 10.3537C40.264 10.4247 40.1206 10.5241 40.0154 10.652C39.9103 10.777 39.8578 10.9389 39.8578 11.1378C39.8578 11.4219 39.9615 11.6364 40.1689 11.7812C40.3762 11.9261 40.6404 11.9986 40.9615 11.9986ZM48.4146 15.5909C47.8606 15.5909 47.3848 15.5156 46.987 15.3651C46.5893 15.2173 46.2697 15.0185 46.0282 14.7685C45.7868 14.5185 45.6191 14.2415 45.5254 13.9375L46.9146 13.6009C46.9771 13.7287 47.068 13.8551 47.1873 13.9801C47.3066 14.108 47.4672 14.2131 47.6689 14.2955C47.8734 14.3807 48.1305 14.4233 48.4402 14.4233C48.8777 14.4233 49.2399 14.3168 49.5268 14.1037C49.8137 13.8935 49.9572 13.5469 49.9572 13.0639V11.8239H49.8805C49.801 11.983 49.6845 12.1463 49.5311 12.3139C49.3805 12.4815 49.1802 12.6222 48.9302 12.7358C48.6831 12.8494 48.372 12.9062 47.997 12.9062C47.4941 12.9062 47.0382 12.7884 46.6291 12.5526C46.2228 12.3139 45.899 11.9588 45.6575 11.4872C45.4189 11.0128 45.2995 10.419 45.2995 9.70597C45.2995 8.98722 45.4189 8.38068 45.6575 7.88636C45.899 7.3892 46.2243 7.01278 46.6333 6.7571C47.0424 6.49858 47.4984 6.36932 48.0012 6.36932C48.3848 6.36932 48.7001 6.43466 48.9473 6.56534C49.1973 6.69318 49.3961 6.84801 49.5439 7.02983C49.6916 7.20881 49.8038 7.37784 49.8805 7.53693H49.9657V6.45455H51.487V13.1065C51.487 13.6662 51.3535 14.1293 51.0865 14.4957C50.8194 14.8622 50.4544 15.1364 49.9913 15.3182C49.5282 15.5 49.0027 15.5909 48.4146 15.5909ZM48.4274 11.696C48.7541 11.696 49.0325 11.6165 49.2626 11.4574C49.4927 11.2983 49.6674 11.0696 49.7868 10.7713C49.9061 10.473 49.9657 10.1151 49.9657 9.69744C49.9657 9.28551 49.9061 8.92472 49.7868 8.61506C49.6703 8.3054 49.497 8.06534 49.2669 7.89489C49.0396 7.72159 48.7598 7.63494 48.4274 7.63494C48.0836 7.63494 47.7967 7.72443 47.5666 7.90341C47.3365 8.08239 47.1632 8.32812 47.0467 8.64062C46.9302 8.95028 46.872 9.30256 46.872 9.69744C46.872 10.098 46.9302 10.4489 47.0467 10.75C47.166 11.0483 47.3407 11.2812 47.5708 11.4489C47.8038 11.6136 48.0893 11.696 48.4274 11.696ZM55.9657 13.1278C55.3095 13.1278 54.7427 12.9915 54.2654 12.7188C53.791 12.4432 53.426 12.054 53.1703 11.5511C52.9146 11.0455 52.7868 10.4503 52.7868 9.76562C52.7868 9.09233 52.9146 8.50142 53.1703 7.9929C53.4288 7.48153 53.7896 7.08381 54.2527 6.79972C54.7157 6.51278 55.2598 6.36932 55.8848 6.36932C56.2882 6.36932 56.6689 6.43466 57.0268 6.56534C57.3876 6.69318 57.7058 6.89205 57.9814 7.16193C58.2598 7.43182 58.4785 7.77557 58.6376 8.19318C58.7967 8.60795 58.8762 9.10227 58.8762 9.67614V10.1491H53.5112V9.10938H57.3975C57.3947 8.81392 57.3308 8.55114 57.2058 8.32102C57.0808 8.08807 56.9061 7.90483 56.6816 7.77131C56.46 7.63778 56.2015 7.57102 55.9061 7.57102C55.5907 7.57102 55.3137 7.64773 55.0751 7.80114C54.8365 7.9517 54.6504 8.15057 54.5169 8.39773C54.3862 8.64205 54.3194 8.91051 54.3166 9.20312V10.1108C54.3166 10.4915 54.3862 10.8182 54.5254 11.0909C54.6646 11.3608 54.8592 11.5682 55.1092 11.7131C55.3592 11.8551 55.6518 11.9261 55.987 11.9261C56.2115 11.9261 56.4146 11.8949 56.5964 11.8324C56.7782 11.767 56.9359 11.6719 57.0694 11.5469C57.2029 11.4219 57.3038 11.267 57.372 11.0824L58.8123 11.2443C58.7214 11.625 58.5481 11.9574 58.2924 12.2415C58.0396 12.5227 57.7157 12.7415 57.3208 12.8977C56.926 13.0511 56.4743 13.1278 55.9657 13.1278ZM65.3546 8.18466L63.9483 8.33807C63.9086 8.19602 63.839 8.0625 63.7395 7.9375C63.6429 7.8125 63.5123 7.71165 63.3475 7.63494C63.1827 7.55824 62.981 7.51989 62.7424 7.51989C62.4213 7.51989 62.1515 7.58949 61.9327 7.72869C61.7168 7.8679 61.6103 8.0483 61.6131 8.26989C61.6103 8.46023 61.6799 8.61506 61.8219 8.73438C61.9668 8.85369 62.2054 8.9517 62.5378 9.02841L63.6543 9.26705C64.2736 9.40057 64.7338 9.61222 65.035 9.90199C65.339 10.1918 65.4924 10.571 65.4952 11.0398C65.4924 11.4517 65.3716 11.8153 65.133 12.1307C64.8972 12.4432 64.5691 12.6875 64.1486 12.8636C63.7282 13.0398 63.2452 13.1278 62.6998 13.1278C61.8986 13.1278 61.2537 12.9602 60.7651 12.625C60.2765 12.2869 59.9853 11.8168 59.8915 11.2145L61.3958 11.0696C61.464 11.3651 61.6088 11.5881 61.8304 11.7386C62.052 11.8892 62.3404 11.9645 62.6955 11.9645C63.062 11.9645 63.356 11.8892 63.5776 11.7386C63.802 11.5881 63.9142 11.402 63.9142 11.1804C63.9142 10.9929 63.8418 10.8381 63.6969 10.7159C63.5549 10.5937 63.3333 10.5 63.0321 10.4347L61.9157 10.2003C61.2878 10.0696 60.8233 9.84943 60.5222 9.53977C60.2211 9.22727 60.0719 8.83239 60.0748 8.35511C60.0719 7.9517 60.1813 7.60227 60.4029 7.30682C60.6273 7.00852 60.9384 6.77841 61.3361 6.61648C61.7367 6.4517 62.1983 6.36932 62.7211 6.36932C63.4881 6.36932 64.0918 6.53267 64.5321 6.85938C64.9753 7.18608 65.2495 7.62784 65.3546 8.18466ZM70.0463 13L73.758 5.65341V5.59375H69.4498V4.27273H75.3944V5.62358L71.687 13H70.0463ZM76.237 13.0938C75.9785 13.0938 75.7569 13.0028 75.5723 12.821C75.3876 12.6392 75.2967 12.4176 75.2995 12.1562C75.2967 11.9006 75.3876 11.6818 75.5723 11.5C75.7569 11.3182 75.9785 11.2273 76.237 11.2273C76.487 11.2273 76.7044 11.3182 76.889 11.5C77.0765 11.6818 77.1717 11.9006 77.1745 12.1562C77.1717 12.3295 77.1262 12.4872 77.0382 12.6293C76.9529 12.7713 76.8393 12.8849 76.6973 12.9702C76.5581 13.0526 76.4047 13.0938 76.237 13.0938ZM81.6362 13.1662C80.9345 13.1662 80.3322 12.9886 79.8294 12.6335C79.3294 12.2756 78.9444 11.7599 78.6745 11.0866C78.4075 10.4105 78.274 9.59659 78.274 8.64489C78.2768 7.69318 78.4118 6.88352 78.6788 6.21591C78.9487 5.54545 79.3336 5.03409 79.8336 4.68182C80.3365 4.32955 80.9373 4.15341 81.6362 4.15341C82.335 4.15341 82.9359 4.32955 83.4387 4.68182C83.9416 5.03409 84.3265 5.54545 84.5936 6.21591C84.8635 6.88636 84.9984 7.69602 84.9984 8.64489C84.9984 9.59943 84.8635 10.4148 84.5936 11.0909C84.3265 11.7642 83.9416 12.2784 83.4387 12.6335C82.9387 12.9886 82.3379 13.1662 81.6362 13.1662ZM81.6362 11.8324C82.1816 11.8324 82.612 11.5639 82.9274 11.027C83.2456 10.4872 83.4047 9.69318 83.4047 8.64489C83.4047 7.9517 83.3322 7.36932 83.1873 6.89773C83.0424 6.42614 82.8379 6.07102 82.5737 5.83239C82.3095 5.59091 81.997 5.47017 81.6362 5.47017C81.0936 5.47017 80.6646 5.74006 80.3493 6.27983C80.0339 6.81676 79.8748 7.60511 79.872 8.64489C79.8691 9.34091 79.9387 9.92614 80.0808 10.4006C80.2257 10.875 80.4302 11.233 80.6944 11.4744C80.9586 11.7131 81.2725 11.8324 81.6362 11.8324Z" fill="url(#paint0_linear_2117_321434)"/>
                  <path d="M89.7607 1.0282C89.833 0.792683 90.1664 0.792683 90.2387 1.0282L90.7179 2.58942C90.811 2.89264 91.0424 3.13372 91.3416 3.23913L92.8306 3.76382C93.0531 3.84224 93.0531 4.15698 92.8306 4.2354L91.3416 4.76008C91.0424 4.86549 90.811 5.10658 90.7179 5.4098L90.2387 6.97101C90.1664 7.20653 89.833 7.20653 89.7607 6.97101L89.2815 5.4098C89.1884 5.10658 88.957 4.86549 88.6579 4.76008L87.1689 4.2354C86.9463 4.15698 86.9463 3.84224 87.1689 3.76382L88.6579 3.23913C88.957 3.13372 89.1884 2.89264 89.2815 2.58942L89.7607 1.0282Z" fill="url(#paint1_linear_2117_321434)"/>
                  <defs>
                  <linearGradient id="paint0_linear_2117_321434" x1="103.641" y1="-1.14082e-05" x2="40.8873" y2="-41.7838" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#D8E1FF"/>
                  <stop offset="1" stop-color="#C8ACFF"/>
                  </linearGradient>
                  <linearGradient id="paint1_linear_2117_321434" x1="92.248" y1="2.03208" x2="89.3859" y2="1.00752" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#D8E1FF"/>
                  <stop offset="1" stop-color="#D8E1FF"/>
                  </linearGradient>
                  </defs>
                  </svg>
                `
      } else {
        this.tooltipPrefix = ''
      }
    },
    $route: {
      deep: true,
      handler(_, from) {
        this.prevRoute = window.location.origin + from.fullPath;

        this.windowResizeHandler();
        // this.checkOpenSubmenu();
      }
    }
  },
  created() {
    this.DASHBOARD_SIDEBAR_EVENT = DASHBOARD_SIDEBAR_EVENT;

    this.$nextTick(() => {
      this.windowResizeHandler();
      this.resizeHandler();
      let handler = this.windowResizeHandler;
      window.addEventListener("resize", handler);
      // this.checkOpenSubmenu();
    });
    if (!(this.$route.name || "").includes("Agency")) {
      this.url = new URL("/admin", "https://" + this.shopInfo.shopifyDomain);
    }

    if (["professional", "advanced", "starter", "plus", "build", "enterprise", "optimize"].includes(this.shopInfo?.plan)) {
      this.showInstant = true;
    }
  },
  async mounted() {
    // this.setDisplayFeedbackMsg();
    this.windowResizeHandler();
    // this.checkOpenSubmenu();
  },
  beforeDestroy() {
    let handler = this.windowResizeHandler;
    this.$nextTick(() => {
      window.removeEventListener("resize", handler);
    });
  },
  methods: {
    ...mapMutations({
      toggleDrawer: "drawer/DRAWER_TOGGLE_DRAWER",
      updateSize: "drawer/DRAWER_UPDATE_WINDOW_SIZE",
      setDisplayFeedback: "drawer/SET_DISPLAY_FEEDBACK"
    }),
    ...mapActions("common", {
      trackEvent: "trackEvent"
    }),
    ...mapActions("page", {
      createPageWithOneTap: "createPageWithOneTap"
    }),
    goTo(routeName) {
      const paramGemPagesV7 = {
        LandingPages: "/instant/landing-pages",
        HomePages: "/instant/home-pages",
        ProductPages: "/instant/product-pages",
        CollectionPages: "/instant/collection-pages",
        ArticlePages: "/instant/article-pages"
      };

      if (this.shopInfo.shopType.isGemPagesMixed) {
        if (routeName == 'LandingPages') {
          return {
            path: paramGemPagesV7[routeName]
          }
        } else {
          return { name: routeName };
        }
      }

      if (this.shopInfo.shopType.isGemPagesV6) {
        return { name: routeName };
      }

      return {
        path: paramGemPagesV7[routeName]
      };
    },
    currentLocation() {
      const prevRoute = this.prevRoute;
      this.prevRoute = null;

      return prevRoute || window.location.href;
    },

    trackSidebarEvent(eventId) {
      this.trackEvent({ event_id: eventId, path: this.currentLocation() });
    },

    async onCreateNewPage(pageType, eventId) {
        await this.trackEvent({ event_id: eventId, path: this.currentLocation() });
  
        if (this.shopInfo.shopType.isGemPagesV7) {
          await createThemeAndPageV7({ pageType, createByGenerateImage: false });
          return;
        }
  
        if (this.shopInfo.shopType.isGemPagesMixed && pageType == 'subpages') {
          await createThemeAndPageV7({ pageType, createByGenerateImage: true });
        } else {
          await this.createPageWithOneTap({ type: pageType });
        }
  
        return false;
    },

    resizeHandler() {},

    windowResizeHandler() {
      // this.setDisplayFeedbackMsg();

      // console.warn("TGGLE");
      this.height = window.innerHeight;
      this.windowWidth = window.innerWidth;
      this.updateSize({
        width: this.windowWidth,
        height: this.height
      });

      // if (!this.$route.meta.allowAutoSidebar) {
      //   // console.warn("This route is not allowed to auto close/open sidebar");
      //   this.toggleDrawer(false);
      //   return;
      // }
      if (this.windowWidth < 1024) {
        // If it's Opening => Close it
        if (!this.isSidebarClosed) {
          // console.warn(
          //   `SIDEBAR CONTROL =>>>>>>> CLOSE SIDEBAR with windowWidth = ${this.windowWidth}`
          // );
          this.toggleDrawer();
        }
      } else {
        // If it's closed => Open it
        if (this.isSidebarClosed) {
          // console.warn(
          //   `SIDEBAR CONTROL =>>>>>>> OPEN SIDEBAR with windowWidth = ${this.windowWidth}`
          // );
          this.toggleDrawer();
        }
      }
    },
    goDashboard() {
      event.preventDefault();
      var protocol = location.protocol;
      var slashes = protocol.concat("//");
      var host = slashes.concat(window.location.hostname);
      alert(host);
      window.location.href = host + "/admin/dashboard";
    },
    goDashboardRoot() {
      let url = window.location.href;
      let arr = url.split("/");
      let host = arr[0] + "//" + arr[2];
      window.location.href = host + "/admin/dashboard";
    },
    // handleOpenFeedback() {
    //   this.gotFeedbackMsg();
    //   openFeedbackForm();
    // },
    isDisplayInSidebar(el) {
      const SIDEBAR_FOOTER_HEIGHT = 70;
      const rect = el.getBoundingClientRect();
      return rect.bottom <= (window.innerHeight - SIDEBAR_FOOTER_HEIGHT || document.documentElement.clientHeight - SIDEBAR_FOOTER_HEIGHT);
    },
    // gotFeedbackMsg() {
    //   const key = "gotFeedbackMsg";
    //   const shopId = this.shopInfo.shopId;
    //   const listItem = localStorage.getItem(key);
    //   const list = listItem ? JSON.parse(listItem) : [];
    //   if (!list.includes(shopId)) {
    //     list.push(shopId);
    //   }
    //   localStorage.setItem(key, JSON.stringify(list));
    //   this.setDisplayFeedback(false);
    // },
    // setDisplayFeedbackMsg() {
    //   const $feedbackItem = document.querySelector(".nav-link-feedback");
    //   const $message = document.querySelector(".feedback-popover");

    //   if (!$message || !$feedbackItem) return;
    //   if (!this.isDisplayInSidebar($feedbackItem)) {
    //     this.setDisplayFeedback(false);
    //     return;
    //   }

    //   const hasNotGotMsg = !localStorage.getItem("gotFeedbackMsg")?.includes(this.shopInfo.shopId);
    //   const hasRecentPage = this.recentPage.length > 0;
    //   this.setDisplayFeedback(hasNotGotMsg && hasRecentPage);

    //   const MESSAGE_POSITION = $feedbackItem.getBoundingClientRect().top - 165;
    //   $message.style.top = `${MESSAGE_POSITION}px`;
    // },
    // observeScroll() {
    //   this.setDisplayFeedbackMsg();
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/core/themes/partials/_utils.scss";
@import "@/core/themes/partials/_tooltips.scss";

// @import "@/core/themes/base.scss";

.sidebar {
  position: fixed;
  margin-top: 60px;
  left: 0;
  top: 0;
  height: 100vh;
  width: 280px;
  background-color: #151617;
  border-top: solid 1px $dark8;
  display: flex;
  flex-direction: column;
  @include trans-all;
  z-index: 49;
  padding: 8px;
  .noHover {
    pointer-events: none;
  }
  > a,
  > a:visited {
    color: $textDarkModeLowContrast;
  }
  > a:hover {
    color: $textDarkModeHigh;
    background-color: $dark5;
  }
  > a:first-child:hover {
    background-color: $dark2;
  }
  .logo {
    // width: calc(100%);
    padding: 11px 16px;
    height: 40px;
    display: flex;
    border-radius: $radius;
    .icon {
      margin-right: 8px;
      font-size: 16px;
    }
    &__text {
      color: $textDarkModeLowContrast;
      line-height: 22px !important;
    }
  }
  .logo-agency {
    padding: 16px;
  }

  section.account-container {
    max-height: 120px;
    background: $dark4;
    position: relative;
    margin-top: auto;
    margin-bottom: 60px;
    border-top: solid 1px $dark8;
    margin-left: -8px;
    .account {
      // height: 100%;
      width: 100%;
    }
  }

  .sidenav {
    display: flex;
    flex-direction: column;
    flex: 1;
    position: relative;
    // width: calc(100% + 2px);
    margin-left: -8px;
    margin-right: -8px;

    .pages {
      margin-bottom: 16px;
    }

    .help-center {
      margin-top: auto;

      .gp_dropdown {
        &_list {
          top: unset;
          bottom: 100%;
          right: -16px;
        }
      }
    }

    .acc-nav {
      margin-bottom: 19px;
    }

    .nav-link {
      padding: 9.5px 16px;
      display: flex;
      position: relative;
      flex-direction: row;
      align-items: center;
      font-weight: 500;
      text-decoration: none;
      @include trans-all;
      @include no-select;
      border-radius: $radius;

      &__quick-add {
        padding: 0;
        $size: 32px;
        width: $size;
        height: $size;
        background: inherit;
        margin-left: auto;
        display: none;
        z-index: 10;
        position: absolute;
        top: calc(50% - #{$size / 2});
        right: 8px;
        .icon {
          top: unset !important;
          font-size: 20px !important;
          line-height: 20px !important;
        }
        &:hover {
          background: $dark5;
        }
      }

      &.rl-active {
        .nav-link__quick-add {
          &:hover {
            background: $dark8;
          }
        }
      }

      .text-item {
        height: 21px;
        font-size: 14px;
        line-height: 21px;
      }

      &:not(.disabled) {
        color: #e2e2e2;
      }

      &.disabled {
        color: $textDarkModeDisabled !important;
        i.icon {
          color: $textDarkModeDisabled !important;
        }
        &.open .arrow i.icon {
          color: $textDarkModeDisabled !important;
        }
      }

      &.view-more {
        padding-left: 0;
      }

      &,
      &:active {
        color: inherit;
      }

      &.subtitle {
        color: $textDarkModeDisabled;
        font-size: 12px;
        line-height: 18px;
        padding-top: 0;
        padding-bottom: 0;
        margin-bottom: 8px;
        letter-spacing: 0.5px;
      }

      svg,
      i.icon {
        margin-right: 8px;
        font-size: 16px;
        line-height: 16px;
        color: $textDarkModeHigh;
        transition: all 0.3s ease;
        position: relative;
        top: 1px;
      }

      &.dashboard {
        margin-bottom: 24px;
      }

      // &:not(:first-child) {
      //   padding-top: calc(16px + 5px);
      // }

      &:not(.subtitle):not(.disabled):not(.rl-active):hover {
        // border-left: 3px solid $dark2;
        svg,
        i.icon {
          color: $textDarkModeHigh;
        }
        .text-item {
          color: #fff;
        }
        background-color: #444545;
        cursor: pointer;
        // .tooltip {
        //   visibility: visible;
        //   opacity: 1;
        //   z-index: 101;
        // }
      }

      &__quick-add {
        i.typo-icon-12 {
          font-size: 18px;
          line-height: 18px;
          color: $light5;
        }
      }
      &:hover .nav-link__quick-add {
        display: flex;
      }
      &.rl-eactive,
      &.rl-active {
        svg,
        i.icon {
          color: #fff;
        }
        .text-item {
          color: #fff;
        }
        padding-left: 16px;
        background-color: #323232;
        cursor: pointer;
      }

      // &.rl-eactive {
      //   color: $cPrimary;
      //   // border-right: 2px solid $cPrimary;
      //   // width: calc(100% - 24px);
      // }

      &.open {
        .arrow {
          display: flex;
          align-items: center;
          margin-left: auto;

          i.icon {
            font-size: 12px;
            line-height: 12px;
            color: $black1;
            font-weight: 500;
          }
        }
      }

      // i.icon.icon-menu {
      //   transform: rotate(90deg);
      // }

      .badge {
        margin-left: 8px;
      }
    }

    .sub-nav {
      background-color: $grey5;
      padding: 5px 0 5px 20px;
      margin-top: 8px;
    }
  }

  &.collapsed {
    width: 80px;
    min-width: 80px;

    .logo {
      i {
        display: none;
      }
      padding-left: 20px;
    }

    .sidenav {
      // padding-top: 20px;

      .nav-link {
        padding-left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        &:not(.subtitle) > span {
          display: none;
        }

        &.subtitle {
          text-align: center;
          padding-left: 0;
          margin-top: 24px;
          padding: 0 8px;

          span {
            width: 100%;
          }
        }

        &:not(:first-child) {
          padding-top: calc(8px + 5px);
        }

        i.icon {
          margin-right: 0px;
          font-size: 26px;
        }

        &.dashboard {
          margin: 0;
        }
      }

      .pages {
        margin-bottom: 0;
      }

      .sub-nav {
        padding-left: 0px;
      }

      .help-center {
        .view-more {
          margin-top: 0;
        }

        .gp_dropdown {
          /deep/ {
            .no-padding {
              padding: 0 0 0 24px;
            }

            .gp_dropdown_list {
              width: 200px;
              left: 10px;

              span {
                display: inline;
              }
            }
          }
        }
      }

      .acc-nav {
        margin: 0 0 16px 0;
      }
    }

    & + .gp-wrapper {
      margin-left: 80px;
    }

    /deep/ .account-container {
      min-height: 36px;
      margin-bottom: 16px;

      .account {
        padding: 9px;
      }

      .name,
      .plan > span {
        display: none;
      }

      .upgrade > i.icon {
        margin: 0 4px !important;
      }
    }

    .toggler {
      width: 25px;
      padding-left: 8px;
    }
  }

  .toggler {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 12px;
    right: -25px;
    padding: 4px;
    height: 24px;
    width: 50px;
    padding-left: 28px;
    border-radius: 0px 5px 5px 0px;
    font-size: 14px;
    background: $dark3;
    color: $textDarkModeHigh;
    cursor: pointer;
    z-index: -1;
  }
}

.badge {
  display: flex;
  padding: 1px 5px;
  font-size: 10px;
  line-height: 10px;
  border-radius: 3px;
  min-width: 16px !important;
  min-height: 16px !important;
  justify-content: center;
  align-items: center;

  &-danger {
    background-color: $cRed;
    color: #fff;
  }
  &-warn {
    // background-color: ;
    border: 1px solid $accent-yellow;
    color: $accent-yellow;
  }

  &-instant {
    color: #fff;
    background-color: $cPrimary;
  }

  &-new {
    border: 1px solid $accent-green;
    color: $accent-green;
  }

  &-pro {
    background: $mono3;
    color: $light1;
    font-size: 12px;
    line-height: 14px;
    font-weight: 500;
  }
}

.feedback-popover {
  display: flex;
  padding: 12px;
  position: absolute;
  width: 244px;
  height: 129px;
  left: 102%;
  color: $neutral5;
  background: $dark6;
  border-radius: 4px;
  &_action {
    @include trans-all;
    width: fit-content;
    padding: 7px 8px;
    border-radius: 3px;
    color: $textDarkModeHigh;
    &:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
  }
  &::after {
    content: "";
    position: absolute;
    right: 100%;
    top: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent $dark6 transparent transparent;
  }
}

.disabled .badge-warn .badge-new {
  opacity: 0.6;
}

.scrollBody {
  max-height: calc(100vh - 60px - 40px - 16px - 74px);
  padding-left: 8px;
  padding-right: 8px;
}

// trial se co them nut de upgrade nen can tinh lai max-height cho scrollBody theo cac breakpoint
.trial-plan {
  .scrollBody {
    max-height: calc(100vh - 60px - 40px - 16px - 120px);
  }
}

// starter cung co them nut de upgrade nen can tinh lai max-height cho scrollBody theo cac breakpoint
.starter-plan {
  .scrollBody {
    max-height: calc(100vh - 60px - 40px - 16px - 120px);
  }
}

@media screen and (min-width: 1440px) {
  .sidebar {
    min-width: 280px;
  }
}

@media screen and (max-width: 1439px) {
  .sidebar {
    min-width: 280px;
    width: 280px;
  }
}

@media screen and (max-width: 1279px) {
  .sidebar {
    width: 224px;
    min-width: 224px;
  }
}

@media screen and (max-width: 1023px) {
  .sidebar {
    /deep/ .account-container {
      margin-bottom: 16px;
    }

    .sidenav .nav-link.subtitle {
      margin-top: 24px;
    }

    &:not(.collapsed) {
      .logo {
        justify-content: flex-start !important;
      }
    }
  }
}

@media screen and (max-height: 672px) {
  .sidebar {
    .sidenav {
      margin-top: 12px;
      .pages {
        margin-bottom: 16px;
      }
      .nav-link {
        &.subtitle {
          margin-bottom: 8px;
        }
        &.dashboard {
          margin-bottom: 16px;
        }
      }
    }

    .account-container {
      padding-top: 12px !important;
      padding-bottom: 12px !important;
    }

    ::v-deep.account {
      .plan {
        margin-bottom: 12px;
      }
    }
  }

  .scrollBody {
    max-height: calc(100vh - 60px - 40px - 12px - 64px);
  }

  .trial-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 40px - 12px - 92px);
    }
  }

  .starter-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 40px - 12px - 102px);
    }
  }
}

@media screen and (max-height: 600px) {
  .sidebar {
    .sidenav {
      margin-top: 8px;
      .pages {
        margin-bottom: 8px;
      }
      .nav-link {
        padding-top: 8px;
        padding-bottom: 8px;
        &.subtitle {
          margin-bottom: 4px;
        }
        &.dashboard {
          margin-bottom: 8px;
        }
      }
    }

    ::v-deep.account {
      .plan {
        margin-bottom: 8px;
      }
    }
  }

  .scrollBody {
    max-height: calc(100vh - 60px - 35px - 8px -70px);
  }

  .trial-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 35px - 8px - 80px);
    }
  }

  .starter-plan {
    .scrollBody {
      max-height: calc(100vh - 60px - 35px - 8px - 90px);
    }
  }
}
</style>
